<template>
    <div>
        <data-loader v-if="isLoading == 1"></data-loader>
        <transition name="fade">
            <t-modal
                name="add-jewel-modal"
                @before-open="onBeforeOpen"
                @open="onOpen"
                @closed="onClose"
                :header="callType + ' Diamond'"
            >
                <div class="mb-4">
                    <notice v-if="source == 'customer'" notice-type="info"
                        >The accuracy of your valuation is as good as the
                        information you provide. If you do not have a laboratory
                        grading certificate seek some help from a professional
                        to eye grade your diamond(s).
                    </notice>
                </div>
                <form
                    action=""
                    @submit="addjewel(jewel)"
                    v-if="!isEmpty(jewelOptions)"
                >
                    <div
                        :class="'flash-notice ' + resultNoticeType"
                        v-if="resultNotice != ''"
                    >
                        {{ resultNotice }}
                    </div>
                    <div class="grid grid-cols-4 gap-4">
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('shape')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.shape.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('shape')"
                                        :tooltip="getHelpText('shape')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.shape"
                                    name="shape"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .shape.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item input-text ' + getClass('carat')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.carat.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('carat')"
                                        :tooltip="getHelpText('carat')"
                                    ></Tooltip>
                                </div>
                                <t-input v-model="jewel.carat" name="carat" />
                                <div
                                    v-if="!caratInRange"
                                    class="text-xs text-red-800 my-2"
                                >
                                    Carat must be between 0.1 &amp; 100
                                </div>
                            </div>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('color')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.color.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('color')"
                                        :tooltip="getHelpText('color')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.color"
                                    name="color"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .color.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('clarity')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.clarity.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('clarity')"
                                        :tooltip="getHelpText('clarity')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.clarity"
                                    name="clarity"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .clarity.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' + getClass('cut')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.cut.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('cut')"
                                        :tooltip="getHelpText('cut')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.cut"
                                    name="cut"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .cut.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('symmetry')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.symmetry.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('symmetry')"
                                        :tooltip="getHelpText('symmetry')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.symmetry"
                                    name="symmetry"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .symmetry.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('polish')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.polish.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('polish')"
                                        :tooltip="getHelpText('polish')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.polish"
                                    name="polish"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .polish.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('fluorescence')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.fluorescence.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('fluorescence')"
                                        :tooltip="getHelpText('fluorescence')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.fluorescence"
                                    name="fluorescence"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .fluorescence.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item select-single ' +
                                    getClass('grading_lab')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{ jewelOptions.grading_lab.label }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('grading_lab')"
                                        :tooltip="getHelpText('grading_lab')"
                                    ></Tooltip>
                                </div>
                                <select
                                    v-model="jewel.grading_lab"
                                    name="grading_lab"
                                    class="form-select single"
                                >
                                    <option value="">-- Select --</option>
                                    <option
                                        v-for="(option, index) in jewelOptions
                                            .grading_lab.options"
                                        :value="index"
                                    >
                                        {{ option.title }}
                                    </option>
                                </select>
                            </div>
                            <div
                                :class="
                                    'form-item input-text mt-2 ' +
                                    getClass('grading_lab_other')
                                "
                                v-if="jewel.grading_lab == 'Other'"
                            >
                                <div class="flex">
                                    <label
                                        >{{
                                            jewelOptions.grading_lab_other
                                                .label
                                        }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('grading_lab_other')"
                                        :tooltip="
                                            getHelpText('grading_lab_other')
                                        "
                                    ></Tooltip>
                                </div>
                                <t-input
                                    v-model="jewel.grading_lab_other"
                                    name="grading_lab_other"
                                />
                            </div>
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <div
                                :class="
                                    'form-item input-text ' +
                                    getClass('lab_report_number')
                                "
                            >
                                <div class="flex">
                                    <label
                                        >{{
                                            jewelOptions.lab_report_number
                                                .label
                                        }}:
                                    </label>
                                    <Tooltip
                                        v-if="getHelpText('lab_report_number')"
                                        :tooltip="
                                            getHelpText('lab_report_number')
                                        "
                                    ></Tooltip>
                                </div>
                                <t-input
                                    v-model="jewel.lab_report_number"
                                    name="lab_report_number"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="submit-container">
                        <t-button
                            :disabled="!isValid"
                            @click.prevent="addJewel(jewel)"
                            variant="secondaryMaterial"
                            type="submit"
                            ><span class="mr-3"
                                >{{ submitBtnTitle
                                }}<i class="fas fa-chevron-right"></i
                            ></span>
                        </t-button>
                    </div>
                </form>
            </t-modal>
        </transition>
    </div>
</template>

<script>
function initialState() {
    return {
        isLoading: 0,
        slotTimeList: {},
        resultNotice: "",
        resultNoticeType: "success",
        callType: "Add",
        editKey: false,
        jewel: {
            clarity: "",
            carat: "",
            color: "",
            cut: "",
            grading_lab: "",
            grading_lab_other: "",
            lab_report_number: "",
            fluorescence: "",
            symmetry: "",
            shape: "",
            polish: "",
        },
    };
}
import _isEmpty from "lodash/isEmpty";
import _inRange from "lodash/inRange";
import _round from "lodash/round";
import { mapGetters } from "vuex";
export default {
    props: {
        editJewel: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
        source: {
            type: String,
            required: true,
            default: "customer",
        },
    },
    data() {
        return initialState();
    },
    mounted() {},
    methods: {
        onBeforeOpen({ params, cancel }) {
            if (_.has(params, "data.editJewel")) {
                this.callType = "Edit";
                this.editKey = params.data.key;
                this.jewel = params.data.editJewel;
            }
        },
        onOpen() {},
        onClose() {
            Object.assign(this.$data, initialState());
            //console.log(this.editKey)
        },
        addJewel(jewel) {
            this.$EventBus.$emit("jewel-add", {
                jewel: jewel,
                key: this.editKey,
            });
            this.resultNotice = "Your diamond has been added.";
            this.resultNoticeType = "success";
            let modal = this.$modal;
            setTimeout(function () {
                modal.hide("add-jewel-modal");
            }, 500);
        },
        isEmpty(val) {
            return _isEmpty(val);
        },
        roundCarat(val) {
            return val; //_round(val, 2);
        },
        getHelpText(field) {
            let helpText = this.jewelOptions[field].helpText[this.source]
                ? this.jewelOptions[field].helpText[this.source].create
                : "";
            return helpText.length > 0 ? helpText : false;
        },
        getClass(field) {
            let elementClass = this.jewelOptions[field].class[this.source]
                ? this.jewelOptions[field].class[this.source].create
                : "";
            if (field == "lab_report_number") {
                elementClass = elementClass + " " + this.reportRequiredClass;
            }
            if (field == "grading_lab_other") {
                elementClass = elementClass + " " + this.otherLabRequiredClass;
            }

            return elementClass.length > 0 ? elementClass : "";
        },
    },
    computed: {
        ...mapGetters(["jewelOptions"]),
        reportRequiredClass() {
            return this.jewel.grading_lab.length > 0 &&
                this.jewel.lab_report_number.length == 0
                ? "required"
                : "";
        },
        otherLabRequiredClass() {
            return this.jewel.grading_lab == "Other" ? "required" : "";
        },
        submitBtnTitle() {
            return this.isValid ? "Save Diamond" : "Enter Required Data";
        },
        caratInRange() {
            this.jewel.carat = this.roundCarat(this.jewel.carat);
            return this.jewel.carat.length == 0 ||
                _inRange(this.jewel.carat, 0.1, 100)
                ? true
                : false;
        },
        isValid() {
            //round carat to 2 dec places
            this.jewel.carat = this.roundCarat(this.jewel.carat);
            var grading_lab_check =
                this.jewel.grading_lab == "Other" &&
                this.jewel.grading_lab_other == ""
                    ? false
                    : true;
            var grading_lab_certificate_check =
                this.jewel.grading_lab.length > 0 &&
                this.jewel.lab_report_number.length == 0
                    ? false
                    : true;
            return (
                this.jewel.clarity !== "" &&
                this.jewel.carat !== "" &&
                _inRange(this.jewel.carat, 0.1, 100) &&
                this.jewel.color !== "" &&
                this.jewel.shape !== "" &&
                grading_lab_check &&
                grading_lab_certificate_check
            );
        },
    },
};
</script>

<style scoped></style>
